export default "__VITE_ASSET__BDcavvjf__";